import { render, staticRenderFns } from "./TopBookShelf.vue?vue&type=template&id=495e5630&"
import script from "./TopBookShelf.vue?vue&type=script&lang=js&"
export * from "./TopBookShelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports